export function StatCard({
  value,
  label,
  color,
  icon,
}: {
  value: number;
  label: string;
  color: string;
  icon?: string;
}) {
  return (
    <div
      className="fade-in"
      style={{
        background: 'var(--card-bg)',
        borderRadius: 12,
        padding: '18px 22px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
        border: '1px solid var(--border)',
        borderTop: `3px solid ${color}`,
      }}
    >
      <div style={{ fontSize: 30, fontWeight: 800, color, letterSpacing: -1 }}>
        {icon ?? ''}
        {value}
      </div>
      <div
        style={{
          fontSize: 11,
          color: 'var(--text-muted)',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: 0.8,
          marginTop: 3,
        }}
      >
        {label}
      </div>
    </div>
  );
}
